"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_orderby_1 = __importDefault(require("lodash.orderby"));

function orderBy(collection, iteratee) {
  return lodash_orderby_1.default(collection, iteratee);
}

exports.orderBy = orderBy;